/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from '@foxtons/fdl/components/Button/index';
import dynamic from 'next/dynamic';
import { Box, Divider, Typography } from '@mui/material';
import { numberWithCommas } from '@utils/helperFunctions';
import styles from './styles';

const Drawer = dynamic(() => import('@mui/material/Drawer'));
const Close = dynamic(() => import('@mui/icons-material/Close'));

export interface NarrowSearchFilterDrawerProps {
  resultCount: number;
  isOpen: boolean;
  onClose: () => void;
  filterList: Record<string, { totalUnits: number; beds: number }>;
  applyFilter: (filterName: string, value: any) => void;
  bedroomCount?: number | string;
}

const buttonStyle = { textDecoration: 'underline' };

export default function NarrowSearchFilterDrawer({
  isOpen,
  onClose,
  resultCount,
  filterList,
  applyFilter,
  bedroomCount
}: NarrowSearchFilterDrawerProps) {
  return (
    <Drawer anchor="right" open={isOpen} onClose={() => onClose()}>
      <Box sx={styles.mainContainer}>
        <Box sx={styles.headerBox}>
          <Typography variant="h3" sx={styles.drawerHeading}>
            There are {numberWithCommas(resultCount - 100)} more properties
          </Typography>
          <Close sx={styles.closeIcon} onClick={() => onClose()} />
        </Box>
        <Divider sx={styles.headerDivider} />
        <Typography sx={styles.text}>
          Please add some filters above to see more properties such as:
        </Typography>
        <Box sx={styles.filtersBox}>
          <Button
            sx={styles.filterButton}
            style={buttonStyle}
            onClick={() => applyFilter('prop_type', 'houses')}
          >
            Just houses
          </Button>
          <Button
            sx={styles.filterButton}
            style={buttonStyle}
            onClick={() => applyFilter('prop_type', 'flats')}
          >
            Just flats or apartments
          </Button>
        </Box>
        {Object.keys(filterList || {}).length > 0 ? (
          <>
            <Typography sx={styles.filterHeading}>
              Narrow your search by limiting the number of bedrooms
            </Typography>
            <Box sx={styles.filtersBox} id="filter-box">
              {Object.values(filterList)
                .sort((a, b) => a.beds - b.beds)
                .filter((item) => Number(item.beds) >= Number(bedroomCount))
                .map((filterValue) => {
                  const beds = filterValue.beds;

                  return (
                    <Button
                      sx={styles.filterButton}
                      key={beds}
                      onClick={() => {
                        const paths = window.location.pathname.split('/');

                        if (paths.at(-1)?.includes('-bedroom')) {
                          paths.pop();
                        }

                        if (beds >= 1) {
                          paths.push(`${beds}-bedroom`);
                        }

                        const url = new URL(window.location.href);

                        url.pathname = paths.join('/');
                        url.searchParams.delete('page');

                        window.location.href = url.toString();
                      }}
                    >
                      <Box component="span" sx={buttonStyle}>
                        {beds === 0
                          ? 'Studio bedroom properties'
                          : `${beds} bedroom properties`}
                      </Box>
                      &nbsp;({filterValue.totalUnits})
                    </Button>
                  );
                })}
            </Box>
          </>
        ) : null}
      </Box>
    </Drawer>
  );
}
